import { combineReducers, createStore, compose, applyMiddleware, Store } from 'redux';
import thunk from 'redux-thunk';

import { IApplicationState, TReduxActions } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';

import {
  region,
  location,
  offersData,
  user,
  temp,
  media,
  filters,
  analytics,
  preloader,
  jsonQuery,
  abUseExperiments,
  newbuildingConsultant,
} from '../../reducers';

/**
 * Хелпер для создания Redux стора
 * @param preloadedState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(preloadedState: IApplicationState, context: IApplicationContext) {
  // ошибка ts - условие не всегда true
  // tslint:disable-next-line:strict-type-predicates
  const composeEnhancers = typeof window === 'undefined'
    ? compose
    : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const reducers = combineReducers<IApplicationState, TReduxActions>({
    analytics,
    offersData,
    jsonQuery,
    region,
    location,
    filters,
    user,
    temp,
    media,
    preloader,
    newbuildingLabel: noOpReducer(null),
    abUseExperiments,
    newbuildingConsultant,
  });

  let storeReminder: Store<IApplicationState, TReduxActions>;

  const middlewares = [thunk.withExtraArgument(context)];

  const createReduxStore = () => createStore(
    reducers,
    preloadedState,
    composeEnhancers(applyMiddleware(...middlewares)),
  );

  if (process.env.NODE_ENV === 'development') {
    // @ts-ignore
    if (!storeReminder) {
      storeReminder = createReduxStore();

      return storeReminder;
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createReduxStore();
}
// реально any
/* tslint:disable-next-line:no-any */
function noOpReducer(defaults: any) {
  /* tslint:disable-next-line:no-any */
  return (state: any) => state || defaults;
}
